'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbErrSrc = fbErrSrc;
function fbErrSrc() {
    return {
        link: function link(scope, element, attrs) {
            element.bind('error', function () {
                if (attrs.src !== attrs.fbErrSrc) {
                    attrs.$set('src', attrs.fbErrSrc);
                }
            });

            attrs.$observe('ngSrc', function (value) {
                if (!value && attrs.fbErrSrc) {
                    attrs.$set('src', attrs.fbErrSrc);
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-err-src.js
// module id = 714
// module chunks = 0